


































import { defineComponent, computed } from '@vue/composition-api';
import { useComponentBase } from '../../base';
import { useRouter } from '../../router';
import { getStore } from '../../store';
import { signout } from '../../oidc';

const componentName = 'app-header';

export default defineComponent({
    props: {},
    name: componentName,
    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const componentBase = useComponentBase();

        const isAccess = computed(() => {
            return route.value.name == 'access';
        });

        const onLogout = async () => {
            signout();
        }

        return {
            isAccess,
            onLogout,
            isAuthenticated: componentBase.isAuthenticated,
            isMobile: componentBase.isMobile,
            loggedUser: componentBase.loggedUser
        }
    }
})

